import { render, staticRenderFns } from "./CreateStudentContainer.vue?vue&type=template&id=061e5098&scoped=true"
import script from "./CreateStudentContainer.vue?vue&type=script&lang=js"
export * from "./CreateStudentContainer.vue?vue&type=script&lang=js"
import style0 from "./CreateStudentContainer.vue?vue&type=style&index=0&id=061e5098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061e5098",
  null
  
)

export default component.exports